// Attendance Log Action Enum
export const AttendanceLogActionEnum = Object.freeze({
  CheckIn: 0,
  CheckOut: 1,
});

export const AttendenceLogActionLabel = Object.freeze({
  [AttendanceLogActionEnum.CheckIn]: "Check In",
  [AttendanceLogActionEnum.CheckOut]: "Check Out",
});
